export var formatMoney = function formatMoney(money) {
  return new Intl.NumberFormat('pt-br', {
    minimumFractionDigits: 2
  }).format(money);
};